module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Search_16"],"path":[{"$":{"d":"M15.62,14l-4.5-4.5a5.51,5.51,0,1,0-1.63,1.63l4.5,4.5ZM6.5,10A3.5,3.5,0,1,1,10,6.5,3.5,3.5,0,0,1,6.5,10Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Search_16.svg
// module id = KlW0
// module chunks = 1